$.validator.addMethod("startsWith", function (value, element, param) {

    if (param == "XX") {
        return true;
    } else {
        if (value.startsWith("0")) {
            value = value.substr(1);
        }

        return value.startsWith(param);
    }
}, "El texto debe comenzar por {0}");